<template>
    <div class="ui active blurring inverted  dimmer">
      <div class="ui loader"></div>
    </div>
</template>

<script>

export default {
  activated: function() {
	//check if user is authenticated or token exists if yes then load him if no then obtain guest token
    this.$store.dispatch('loadUser').then((response) => {
      //preload categories
	  this.$store.dispatch('loadCategory').then((response) => {
        this.appReady = true;
        this.loadActiveCart();
        this.$store.dispatch('loadOrderWaitingForDelivery'); //to update top menu
	    this.returnToPreviousPage(); //go back to previous page
      }).catch((error) => {
	    console.log(error);
	    //this.$router.go(); //reload page
	  });
    }).catch((error) => {
        this.$store.dispatch('createGuestToken').then((response) => {
          //hide (this will trigger redirect to home page)
          //$('#loginModal').modal('hide all');
          //preload categories
	      this.$store.dispatch('loadCategory').then((response) => {
	        this.returnToPreviousPage(); //go back to previous page
          }).catch((error) => {
	        console.log(error);
	        //this.$router.go(); //reload page
	      });
        });
    }).finally(() => {});
  },

  methods: {
    loadActiveCart() {
      this.$store.dispatch('loadActiveCart').then((response) => {
        this.$store.dispatch('loadCartItems', response.data.data.id);
      }).catch((error) => {
         if(error.response && error.response.status == 404) {
         //if there is no active cart then create new cart
          this.$store.dispatch('createCart')
         }
      });
    },

    returnToPreviousPage(){
      var path = this.$route.query.to;
      if (path == 'loading') path = 'login';
      if (!path && path == '') path = 'home';
      this.$router.push(path);
    }
  }
}
</script>


// WEBPACK FOOTER //
// LoadingApp.vue?381e30d9